export const FLEXAPP_AMP_DEVICE_ID = 'flexapp/amp_device_id'
